export default __webpack_public_path__ + "static/media/users-clients-active.03ecd56e.svg";